import { useTranslation } from 'hooks';
import { IconCertificateLine, IconChevronDown } from 'components/icons';
import { isEmpty, map } from 'lodash';
import { DetailProjectPageContext } from 'pages/du-an/[chi-tiet-du-an]';
import { useContext, useState } from 'react';

const LegalInformation = () => {
  const translate = useTranslation();
  const { project } = useContext(DetailProjectPageContext).pageData ?? {};
  const { project: projectDetail } = project ?? {};
  const { legals } = projectDetail ?? {};
  const [isExpandAccordion, setExpandAccordion] = useState(true);

  const toggleExpandAccordion = () => {
    setExpandAccordion(!isExpandAccordion);
  };

  return !isEmpty(legals) ? (
    <section id='legal-information' className='rounded-[16px] bg-paper p-[24px] shadow-7'>
      <div className='flex justify-between'>
        <div className='flex items-center'>
          <div className='flex h-[30px] w-[30px] items-center justify-center rounded-[8px] bg-background'>
            <IconCertificateLine className='h-[18px] w-[18px]' />
          </div>
          <h2 className='ml-[8px] text-[18px] font-[600] leading-[23px]'>
            {translate.desktop.detailProject.legals}
          </h2>
        </div>
        <div
          className='flex cursor-pointer select-none items-center text-primary'
          onClick={toggleExpandAccordion}
        >
          <span className='text-[12px] leading-[15px]'>
            {isExpandAccordion ? 'Ẩn bớt' : 'Xem thêm'}
          </span>
          <IconChevronDown
            className={`ml-[6px] h-[15px] w-[15px] font-[800] ${
              isExpandAccordion && 'rotate-180'
            } duration-[200ms]`}
          />
        </div>
      </div>
      <div className={`${isExpandAccordion ? 'max-h-fit' : 'max-h-0'} overflow-hidden`}>
        <ul className='mx-[-5px] flex flex-wrap'>
          {map(legals, (legal, legalIndex) => (
            <li
              key={`project-legal-${legalIndex}`}
              className='mt-[15px] w-full px-[5px] lg:basis-1/2'
            >
              {(translate.major.projectLegals as any)[legal]}
            </li>
          ))}
        </ul>
      </div>
    </section>
  ) : null;
};

export default LegalInformation;
